import { CameraIcon, PaperclipIcon } from '../../../../../../../assets/icons/common';
import { PHOTO_FILE_TYPES, PHOTO_UPLOAD_HINT, VIDEO_CONSTRAINTS } from '../../../../constants';
import { PhotoCapture } from '../../../../hooks/usePhotoCapture';
import DropBox from '../../../../../../../containers/DropBox';
import Button from '../../../../../../../components/Button';
import { KycCaptureCopy } from '../../../../types';
import styles from './style.module.scss';
import Webcam from 'react-webcam';

interface Props {
    copy: KycCaptureCopy;
    capture: PhotoCapture;
};

/** Collects one KYC photo, either from the webcam or from a file the applicant picks. */
function CaptureStep(props: Props) {
    const { copy, capture } = props;
    const { mode, file, imgSrc, webcamRef, setFile, toggleMode, captureOrRetake } = capture;
    const isCamera = mode === 'Camera';

    return (
        <>
            <div className={styles.box}>
                {isCamera ? <>
                    <span className={styles.box_title}>{copy.cameraTitle}</span>
                    <div className={styles.sample}>
                        <img src={copy.sample} alt='sample' />
                    </div>
                    <div className={styles.camera}>
                        {imgSrc ? <img src={imgSrc} alt={copy.imageAlt} /> : <Webcam
                            width={1280}
                            height={720}
                            audio={false}
                            ref={webcamRef}
                            disablePictureInPicture
                            forceScreenshotSourceSize
                            screenshotFormat='image/png'
                            videoConstraints={VIDEO_CONSTRAINTS}
                        />}
                    </div>
                    <div className={styles.actions}>
                        <Button
                            type='Outline-Primary'
                            icon={<CameraIcon />}
                            onClick={captureOrRetake}
                            className={styles.box_actions_btn}
                            text={imgSrc ? 'Retake photo' : 'Take photo'}
                        />
                    </div>
                </> : <>
                    <span className={styles.box_title}>{copy.uploadTitle}</span>
                    <DropBox
                        file={file}
                        uploading={false}
                        setFile={setFile}
                        fileTypes={PHOTO_FILE_TYPES}
                        description={PHOTO_UPLOAD_HINT}
                    />
                </>}
            </div>

            <div className={styles.change_option}>
                <span className={styles.change_option_text}>
                    {isCamera ? copy.cameraHint : copy.uploadHint}
                </span>
                <div className={styles.change_option_link} onClick={toggleMode}>
                    {isCamera ? <PaperclipIcon /> : <CameraIcon />}
                    <span>{isCamera ? ' Upload document' : 'Take photo'}</span>
                </div>
            </div>
        </>
    );
};

export default CaptureStep;
